<template>
    <rkm-modal
        ref="modal"
        title="Histórico do atendimento"
        extraLarge
    >
        <FormHistoricoAmbulatorio
            :data="model.data"
        />
        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
                color="secondary"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>
<script>

// Components.
import FormHistoricoAmbulatorio from './Form'

// Mixin.
import { permissao } from '@/mixins'

export default {
    components: { FormHistoricoAmbulatorio },
    data: () => ({
        model: {
            data: null,
        },
    }),
    methods: {
        open(dados) {
            this.model.data = dados

            this.$refs.modal.show()
        },
    },
    mixins: [ permissao ],
}
</script>